import axios from "axios";

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

if (csrfToken) {
  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
}

export async function createIssue(issue, formData) {
  return await axios.post(`/caregivers/issues/${issue.id}/consultation_reports.json`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function updateReport(issue, report, formData) {
  return await axios.put(`/caregivers/issues/${issue.id}/consultation_reports/${report.id}.json`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteAttachment(issue, report, attachmentId) {
  return await axios.delete(`/caregivers/issues/${issue.id}/consultation_reports/${report.id}/delete_attachment.json`, {
    params: { attachment_id: attachmentId }
  });
}
